import i18n from '~/i18n';
import { DateTime } from 'luxon';

export const TranslationMixin = (superClass) => class extends superClass {
  constructor() {
    super();
    if (this.requestUpdate) {
      this._onLanguageChanged = () => this.requestUpdate();
      i18n.on('languageChanged', this._onLanguageChanged);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._onLanguageChanged) {
      i18n.off('languageChanged', this._onLanguageChanged);
    }
  }

  get language() {
    return i18n.language;
  }

  t(key, options = {}) {
    return i18n.t(key, options);
  }

  localizedFormatDate(date, format = DateTime.DATE_MED) {
    return DateTime.fromISO(date).toLocaleString(format, { locale: i18n.language });
  }

  localizedFormatNumber(number, precision) {
    if (Number.isNaN(number)) {
      return '-';
    }
    const options = {};
    if (precision) {
      options.minimumFractionDigits = precision;
      options.maximumFractionDigits = precision;
    }
    return Intl.NumberFormat(i18n.language, options).format(number);
  }
};
